// Stub file — cxone-games module was removed. These types are still referenced
// by gamification components and services.

export enum IntervalType {
    Day = 0,
    Week = 1,
    Month = 2,
}

export interface GameObject {
    [key: string]: any;
}

export interface RankingByLogin {
    [key: string]: any;
}

export interface GameActionObject {
    [key: string]: any;
}
